<script>
import HsScroll from 'base/hs-scroll/hs-scroll'
import HsDialog from 'base/hs-dialog/hs-dialog'
import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import {ages} from "@/components/c-check-room/c-check-room";
import HsTag from "@/base/hs-tag/hs-tag.vue";

export default {
  name: "c-check-room-ages",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    age: {
      type: [Number, String],
      default: 0
    },
    position: {
      type: String,
      default: ''
    },
    positionHeight: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      currentAge: 0
    }
  },
  computed: {
    currentShow: {
      get: function () {
        return this.show
      },
      set: function (val) {
        this.$emit('update:show', val)
      }
    },
    currentList() {
      let currentList = ages
      if (this.list && this.list.length > 0) {
        currentList = [...this.list]
      }
      return currentList
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.currentAge = this.age
      }
    }
  },
  methods: {
    /** 确认 */
    confirm(age, index, item) {
      this.$emit('delegate', age, index, item)
      this.close()
    },

    /** 关闭 */
    close() {
      this.$refs.refDialog && this.$refs.refDialog.close()
    }
  },
  components: {
    HsScroll,
    HsDialog,
    CDialogHeader,
    HsTag
  }
}
</script>

<template>
  <hs-dialog ref="refDialog" v-model="currentShow" :position="position" :positionHeight="positionHeight">
    <div class="starAndPriceDialog" :class="{ 'hs-filter-top': position === 'top' }" @click.stop>
      <c-dialog-header :title="title || $t('PleaseSelectTheRoomAndRoomer')" @close="close"/>
      <hs-scroll class="table-view" ref="tableView">
        <div class="cell">
          <hs-tag
              type="small"
              v-for="(item) in currentList"
              :key="item.value"
              :title="item.text"
              :subTitle="item.subTitle"
              :active="currentAge === item.value"
              @click.native="confirm(item.value, index, item)"
          />
        </div>
      </hs-scroll>
    </div>
  </hs-dialog>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.starAndPriceDialog {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: $color_black_0;
  max-height: 90%;
  min-height: 460px;
  overflow-y: auto;
  border-radius: 10px 10px 0 0;

  &.hs-filter-top {
    bottom: auto;
    top: 0;
    border-radius: 0;
  }

  .table-view {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .cell {
      @extend .flex-start;
      flex-wrap: wrap;
      padding: 15px 12px;

      > .hs-tag {
        width: calc(25% - 6px);
        margin-bottom: 8px;
        margin-right: 8px;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }

  footer {
    @extend .flex-between;
    width: 100%;
    box-shadow: 0 5px 10px $color_gray_layer;
    padding: 16px 12px;
    margin-bottom: 0;

    .hs-button {
      border-radius: 8px;
    }
  }
}
</style>
